const COURSE_TYPE_INITIAL_STATE = {
  isFetchLoading: false,
  fetchError: undefined,
  data: undefined,
  isUpdateDetailsLoading: false,
  updateDetailsError: undefined,
  isImageDetailsLoading: false,
  imageDetailsError: undefined,
}

export default COURSE_TYPE_INITIAL_STATE
